import React from "react";
import { LegalLayout, H2, P, UL, LI } from "@/components/LegalLayout";

export default function SubscriptionTerms() {
  return (
    <LegalLayout
      title="Subscription Terms"
      updated="June 1, 2026"
      intro="These terms describe Next Time Pro billing, renewals, cancellations, and refunds."
    >
      <H2>1. Next Time Pro</H2>
      <P>Next Time Pro is an optional paid subscription that unlocks features such as unlimited role-plays, a fresh daily scenario, custom scenarios, full pattern history, and data export. Specific features and prices are shown in the app at the time of purchase.</P>

      <H2>2. Free tier</H2>
      <P>You can use core parts of Next Time for free, including a limited number of role-plays and moment analyses in a given period. Free limits are described in the app and may change over time.</P>

      <H2>3. Billing and auto-renewal</H2>
      <UL>
        <LI>Subscriptions are offered on a recurring basis (for example, monthly or annual) and <strong>renew automatically</strong> unless cancelled.</LI>
        <LI>Purchases made through the Apple App Store or Google Play are billed by that store to your store account, and are subject to the store’s own terms.</LI>
        <LI>Your payment method is charged at confirmation of purchase and at the start of each renewal period, at the then-current price.</LI>
      </UL>

      <H2>4. Managing and cancelling</H2>
      <UL>
        <LI>You can manage or cancel auto-renewal at any time in your Apple App Store or Google Play account settings.</LI>
        <LI>Cancellation takes effect at the end of the current billing period; you keep Pro access until then.</LI>
        <LI>Deleting the app does not cancel a subscription.</LI>
      </UL>

      <H2>5. Free trials and promotional offers</H2>
      <P>If a free trial or promotional offer is provided, unused portions are forfeited when you purchase a subscription (where applicable). If you do not cancel before a trial ends, it may convert to a paid subscription automatically. Promotional codes are subject to their stated conditions and have no cash value.</P>

      <H2>6. Price changes</H2>
      <P>We may change subscription prices. Where required, we will give you advance notice, and changes to renewal prices take effect on your next billing period after the change.</P>

      <H2>7. In-app points (one-time purchases)</H2>
      <UL>
        <LI>Points are a virtual item used inside Next Time to unlock mascots. You can also earn them for free through daily practice.</LI>
        <LI>Point packs are one-time (consumable) purchases, not a subscription. The exact price and currency are shown on the purchase screen before you confirm and may vary by region.</LI>
        <LI>Payment is charged to your Apple App Store or Google Play account at confirmation of purchase, and your points balance is credited to your account.</LI>
        <LI>Points have no monetary value, cannot be exchanged for cash, and cannot be transferred, refunded, or redeemed outside the app.</LI>
        <LI>Purchased points do not expire while your account is active. Unused points are forfeited if your account is deleted.</LI>
        <LI>Because point packs are consumed on purchase, they are generally non-refundable except where required by law; refunds are handled by Apple/Google under their policies.</LI>
      </UL>

      <H2>8. Refunds</H2>
      <P>Payments are generally non-refundable except where required by law. Because purchases are processed by the app stores, refund requests are handled according to the applicable store’s refund policy (Apple or Google). We are unable to issue refunds directly for store purchases.</P>

      <H2>9. Cancellation by us</H2>
      <P>We may suspend or cancel a subscription if payment fails, if terms are violated, or if the Service is discontinued. Where a feature is discontinued, we will act reasonably and in accordance with applicable law.</P>

      <H2>10. Contact</H2>
      <P>Questions about billing? Email <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a>. For purchases made through an app store, you may also need to contact that store directly.</P>
    </LegalLayout>
  );
}
